module.exports = __webpack_public_path__ + "static/Wojtek-2023-edited.79f3ef78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Wojtek-2023-edited.jpg
// module id = 170
// module chunks = 35783957827783 263791100135453